import { useApiMutation } from '../../apis/useApi';
import { toast } from 'react-toastify';
import { Dispatch } from 'react';
import { UnknownAction } from '@reduxjs/toolkit';
import { UserAccount, UserDetails } from '../../utils/Config';
import { setUserDetails } from '../slices/userDetailsSlice';
import { setRequestorDetails } from '../slices/requestorDetailsSlice';
const scopeKey = "BID Partner"
export const useUserActions = () => {
    const getUserInfo = useApiMutation<UserAccount, {}>(
        `/o/headless-admin-user/v1.0/my-user-account`,
        'get'
    );
 
    const getPartnerByEmail = useApiMutation<any, {}>(
        `o/c/matchmakingrequestors/scopes/${scopeKey}`,
        "get"
    );
    const getUserInfoData = () => async (dispatch: Dispatch<UnknownAction>) => {
        getUserInfo.mutate(
            {
                data: {},
                params: {
                    p_auth: (window as any)?.Liferay?.authToken
                }
            },
            {
                onSuccess: (data) => {
                    if (data && Object.keys(data).length > 0) {
                        let tempUserData: UserDetails = {
                            name: data.name,
                            mobileNumber:
                                data.userAccountContactInformation.telephones.find(
                                    (item) => item.primary
                                )?.phoneNumber || '',
                            emailAddress: data.emailAddress,
                            roleBriefs: data.roleBriefs,
                            image: data.image
                        };


                        // Save to Redux
                        dispatch(setUserDetails(tempUserData));
                        getPartnerByEmail.mutate(
                            {
                                data: {},
                                params: {
                                    p_auth: (window as any)?.Liferay?.authToken,
                                    filter: `requestorWorkEmail eq '${data.emailAddress}'`,
                                    restrictFields: 'actions',
                                    nestedFields: 'matchMakingToAttachment'
                                }
                            },
                            {
                                onSuccess: (requestorData) => {
                                    if (requestorData?.items?.length > 0) {
                                        dispatch(
                                            setRequestorDetails(
                                                requestorData.items
                                            )
                                        );
                                    }
                                },
                                onError: (error: any) => {
                                    console.error(
                                        'Failed to fetch partner:',
                                        error
                                    );
                                }
                            }
                        );
                    } else {
                        console.error('No data received');
                    }
                },
                onError: (error: any) => {
                    toast.error(
                        error?.response?.data?.message ||
                            error?.response?.data?.message
                    );
                }
            }
        );
    };

    return {
        getUserInfoData
    };
};
